require('./circle');
require('./rect');
require('./ellipse');
require('./diamond');
require('./triangle');
require('./modelRect');
require('./star');
require('./image');
